
import { SvgIcon } from '@mui/material';
import {  observer } from 'mobx-react';
import React, { Component } from 'react';
import { IPropsSvgIcone } from '../../modelo/Icone';



class IconeGE extends Component<IPropsSvgIcone> {

    render() {
        return (
            <SvgIcon {...this.props}>

                <path fill={this.props.htmlColor || 'currentColor'}
                    d="M 4.01,4.70
                   C 4.01,4.70 9.01,4.70 9.01,4.70
                     10.01,4.71 9.99,6.51 9.00,6.52
                     9.00,6.52 5.98,6.48 5.98,6.48
                     5.98,6.48 5.99,12.99 5.99,12.99
                     5.99,12.99 18.00,12.99 18.00,12.99
                     18.00,12.99 18.02,6.41 18.02,6.41
                     18.02,6.41 15.01,6.40 15.01,6.40
                     14.04,6.39 14.02,4.69 15.01,4.68
                     15.01,4.68 20.02,4.65 20.02,4.65
                     20.02,4.65 20.01,15.24 20.01,15.24
                     20.01,15.24 3.98,15.25 3.98,15.25
                     3.98,15.25 4.01,4.70 4.01,4.70 Z
                   M 17.01,17.41
                   C 17.01,17.41 17.01,19.48 17.01,19.48
                     17.01,19.48 6.99,19.52 6.99,19.52
                     6.99,19.52 7.01,17.43 7.01,17.43
                     7.01,17.43 17.01,17.41 17.01,17.41 Z
                   M 15.00,12.01
                   C 15.00,12.01 15.00,6.45 15.00,6.45
                     15.00,6.45 9.56,6.44 9.56,6.44
                     9.56,6.44 9.52,11.99 9.52,11.99
                     9.52,11.99 15.00,12.01 15.00,12.01 Z"
                />
            </SvgIcon>
        );
    }
}

export default observer(IconeGE);
